import React from 'react';
import {
    Button,
    Radio,
    ControlLabel,
    FormControl,
    FormGroup,
    Modal,
    Panel,
    Row,
    Tab,
    Tabs,
    Col
} from 'react-bootstrap';

import bowser from 'bowser';

import T from 'i18n-react';

require('bootstrap/dist/css/bootstrap.css');

export default class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        let data = this.props.data || {};
        this.state = {
            helpStep: 1,
            //name: data.name || '',
            //email: data.email || '',
            gender: data.gender || 'other',
            age: data.age || '',
            profession: data.profession || '',
            //country: data.country || ''
        };

        this.unsupported = bowser.safari || bowser.ios;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleHelpNext = this.handleHelpNext.bind(this);
        this.handleTabSelect = this.handleTabSelect.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit() {
        this.props.onSubmit({
            //name: this.state.name,
            //email: this.state.email,
            gender: this.state.gender,
            age: this.state.age,
            profession: this.state.profession,
            //country: this.state.country,
        })
    }

    handleKeyDown(e) {
        switch (e.key) {
            case 'Enter':
                this.handleSubmit();
                break;
            case 'Escape':
                this.props.onClose();
                break;
            default:
                break;
        }
    }

    handleHelpNext() {
        this.setState({
            helpStep: this.state.helpStep + 1
        });
    }

    handleTabSelect(helpStep) {
        this.setState({helpStep});
    }

    render() {
        return (
            <div className="static-modal">
                <Modal.Dialog>
                    <Modal.Header>
                        <Modal.Title>{ this.unsupported ? T.translate('loginForm.unsupported.title') : T.translate('loginForm.modal.title') }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12}>
                                <a href="http://ltim.uib.es"><img className="img-responsive" src="assets/logos.jpg"/></a>
                            </Col>
                        </Row>
                        { this.unsupported
                            ? <div>
                                <Panel bsStyle="danger">
                                    {T.translate('loginForm.unsupported.body')}
                                </Panel>
                            </div>
                            : <div>
                                <Tabs activeKey={this.state.helpStep} id="login-help-tabs" onSelect={this.handleTabSelect}>
                                    <Tab eventKey={1} title={T.translate('loginForm.modal.help.title')}>
                                        <Panel>
                                            {T.translate('loginForm.modal.help.body')}
                                        </Panel>
                                        <img className="img-responsive" src="assets/help.png" />
                                        <Button bsStyle="default" onClick={this.handleHelpNext}>Next</Button>
                                    </Tab>
                                    <Tab eventKey={2} title={T.translate('loginForm.modal.research.title')}>
                                        <Panel>
                                            {T.translate('loginForm.modal.research.body')}
                                        </Panel>
                                        <form onKeyDown={this.handleKeyDown}>
                                            {/*<FormGroup>*/}
                                                {/*<ControlLabel>{T.translate('loginForm.modal.research.form.titles.name')}:</ControlLabel>*/}
                                                {/*<FormControl*/}
                                                    {/*type="text"*/}
                                                    {/*name="name"*/}
                                                    {/*value={this.state.name}*/}
                                                    {/*onChange={this.handleChange}*/}
                                                    {/*autoFocus*/}
                                                {/*/>*/}
                                            {/*</FormGroup>*/}
                                            {/*<FormGroup>*/}
                                                {/*<ControlLabel>{T.translate('loginForm.modal.research.form.titles.email')}:</ControlLabel>*/}
                                                {/*<FormControl*/}
                                                    {/*type="email"*/}
                                                    {/*name="email"*/}
                                                    {/*value={this.state.email}*/}
                                                    {/*onChange={this.handleChange}*/}
                                                {/*/>*/}
                                            {/*</FormGroup>*/}
                                            <FormGroup>
                                                <ControlLabel>{T.translate('loginForm.modal.research.form.titles.gender')}:</ControlLabel><br/>
                                                <Radio
                                                    name="gender"
                                                    value="male"
                                                    inline
                                                    checked={this.state.gender === 'male'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.gender.male')}
                                                </Radio>
                                                <Radio
                                                    name="gender"
                                                    value="female"
                                                    inline
                                                    checked={this.state.gender === 'female'}
                                                    onChange={this.handleChange}
                                                    >
                                                    {T.translate('loginForm.modal.research.form.data.gender.female')}
                                                </Radio>
                                                {/*<Radio
                                                    name="gender"
                                                    value="other"
                                                    inline
                                                    checked={this.state.gender === 'other'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.gender.other')}
                                                </Radio>*/}
                                            </FormGroup>
                                            <FormGroup>
                                                <ControlLabel>{T.translate('loginForm.modal.research.form.titles.age')}:</ControlLabel><br/>
                                                <Radio
                                                    name="age"
                                                    value="-18"
                                                    inline
                                                    checked={this.state.age === '-18'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.age.-18')}
                                                </Radio>
                                                <Radio
                                                    name="age"
                                                    value="18+"
                                                    inline
                                                    checked={this.state.age === '18+'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.age.18+')}
                                                </Radio>
                                                <Radio
                                                    name="age"
                                                    value="30+"
                                                    inline
                                                    checked={this.state.age === '30+'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.age.30+')}
                                                </Radio>
                                                <Radio
                                                    name="age"
                                                    value="50+"
                                                    inline
                                                    checked={this.state.age === '50+'}
                                                    onChange={this.handleChange}
                                                >
                                                    {T.translate('loginForm.modal.research.form.data.age.50+')}
                                                </Radio>
                                            </FormGroup>
                                            <FormGroup>
                                                <ControlLabel>{T.translate('loginForm.modal.research.form.titles.profession')}:</ControlLabel>
                                                <FormControl
                                                    componentClass="select"
                                                    name="profession"
                                                    value={this.state.profession}
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">----</option>
                                                    <option value="student">{T.translate('loginForm.modal.research.form.data.profession.student')}</option>
                                                    <option value="education">{T.translate('loginForm.modal.research.form.data.profession.education')}</option>
                                                    <option value="ngo">{T.translate('loginForm.modal.research.form.data.profession.ngo')}</option>
                                                    <option value="government">{T.translate('loginForm.modal.research.form.data.profession.government')}</option>
                                                    <option value="office">{T.translate('loginForm.modal.research.form.data.profession.office')}</option>
                                                    <option value="audiovisual">{T.translate('loginForm.modal.research.form.data.profession.audiovisual')}</option>
                                                    <option value="computer">{T.translate('loginForm.modal.research.form.data.profession.computer')}</option>
                                                    <option value="others">{T.translate('loginForm.modal.research.form.data.profession.others')}</option>
                                                </FormControl>
                                            </FormGroup>
                                        </form>
                                    </Tab>
                                </Tabs>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.helpStep === 2 ?
                            <div><Button onClick={this.props.onClose}>{T.translate('loginForm.modal.research.close')}</Button>
                            <Button bsStyle="primary" onClick={this.handleSubmit}>{T.translate('loginForm.modal.research.submit')}</Button></div>
                            :
                            null
                        }
                    </Modal.Footer>
                </Modal.Dialog>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/LoginForm.jsx